import { FunctionComponent } from "react";

import { Typography } from "@digital-services/ui";

const Title: FunctionComponent = () => {
  return (
    <div className="min-w-max grow p-5 text-center" data-testid="header-title">
      <Typography variant="pageTitle">ABB E-mobility Portal</Typography>
    </div>
  );
};

export default Title;
